module.exports = __webpack_public_path__ + "static/media/27-10.2c633a63.mp3";